// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jNpgRTBTAbsg25UxSz8T {
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 8px;
  border-radius: 8px;
}

.l4Pc2HKi8nAyHcrsaeNV {
  overflow-y: auto;
  height: calc(100% - 50px);
}

.duyeCq84KAINlCeK9DQx {
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.qRrYqyrLTi96ZB_RrFQP {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.zLsClUFaVnlgYg_M1K4P {
  display: flex;
  flex-direction: row;
  column-gap: 32px;
  width: 100%;
  justify-content: space-between;
}

.VeAZQQLAjiaSQ0LhLXMq {
  width: 50%;
}

.xIHuK1WnHq5TWbhPhsaw {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.QxWX6mtn0gvUWk0VKIxi {
  font-family: "Chakra Petch";
  font-size: 20px;
  font-weight: 500;
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  min-width: 500px;
  min-height: 500px;
  justify-content: space-between;
}

.izwTeYfME1t7TCcC3Ob_ {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}

.RMFOTkAYfwTdYBtxA8g7 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 32px;
}

.UZ8c6NGfef1BtmnZMu0a {
  min-width: 150px;
}

.A0dLQyeGL6TJyvpopLWa {
  max-height: 30vh;
  overflow-y: auto;
}

.a5hu2ZFWjXqJOP4aau57 {
  width: 50%;
}`, "",{"version":3,"sources":["webpack://./src/screens/IdoCreateOrEdit/Participation.module.scss"],"names":[],"mappings":"AACA;EACI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,8BAAA;AAAJ;;AAGA;EACI,UAAA;AAAJ;;AAGA;EACI,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;AAAJ;;AAGA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,UAAA;AAAJ","sourcesContent":["\r\n.idoAdminContainer {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: white;\r\n    padding: 8px;\r\n    border-radius: 8px;\r\n}\r\n\r\n.idoTableContainer {\r\n    overflow-y: auto;\r\n    height: calc(100% - 50px);\r\n}\r\n\r\n.idoTableFooter {\r\n    width: 100%;\r\n    height: 50px;\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.editIDOContainer {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.participationFilterContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    column-gap: 32px;\r\n    width: 100%;\r\n    justify-content: space-between;\r\n}\r\n\r\n.participationFilterTextInput {\r\n    width: 50%;\r\n}\r\n\r\n.deleteIdoModalOverlay {\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 1000;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.deleteIdoModal {\r\n    font-family: \"Chakra Petch\";\r\n    font-size: 20px;\r\n    font-weight: 500;\r\n    background-color: white;\r\n    border-radius: 8px;\r\n    padding: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-width: 500px;\r\n    min-height: 500px;\r\n    justify-content: space-between;\r\n}\r\n\r\n.generateAllocationContent {\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 16px;\r\n}\r\n\r\n.deleteRow {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    margin-top: 32px    ;\r\n}\r\n\r\n.selectInputContainer {\r\n    min-width: 150px;\r\n}\r\n\r\n.jsonContainer {\r\n    max-height: 30vh;\r\n    overflow-y: auto;\r\n}\r\n\r\n.maxAllocationContainer {\r\n    width: 50%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"idoAdminContainer": `jNpgRTBTAbsg25UxSz8T`,
	"idoTableContainer": `l4Pc2HKi8nAyHcrsaeNV`,
	"idoTableFooter": `duyeCq84KAINlCeK9DQx`,
	"editIDOContainer": `qRrYqyrLTi96ZB_RrFQP`,
	"participationFilterContainer": `zLsClUFaVnlgYg_M1K4P`,
	"participationFilterTextInput": `VeAZQQLAjiaSQ0LhLXMq`,
	"deleteIdoModalOverlay": `xIHuK1WnHq5TWbhPhsaw`,
	"deleteIdoModal": `QxWX6mtn0gvUWk0VKIxi`,
	"generateAllocationContent": `izwTeYfME1t7TCcC3Ob_`,
	"deleteRow": `RMFOTkAYfwTdYBtxA8g7`,
	"selectInputContainer": `UZ8c6NGfef1BtmnZMu0a`,
	"jsonContainer": `A0dLQyeGL6TJyvpopLWa`,
	"maxAllocationContainer": `a5hu2ZFWjXqJOP4aau57`
};
export default ___CSS_LOADER_EXPORT___;
